import { Stepper as MuiStepper, styled } from "@mui/material";

export const Stepper = styled(MuiStepper)(({theme, orientation}) => ({
  ".MuiStepLabel-alternativeLabel": {
    flexDirection: orientation === "vertical" ? "row !important" : "column",
  },
  ".MuiStepLabel-labelContainer span": {
    fontSize: 14,
    lineHeight: orientation === "vertical" ? 5 : 1,
    display: orientation === "vertical" ? "inline" : "block",
  },
  "& .MuiStepLabel-root .Mui-completed": {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  "& .MuiStepLabel-label.MuiStepLabel-alternativeLabel": {
      color: theme.palette.primary.main,
      fontWeight: 400,
  },
  "& .MuiStepLabel-root .Mui-active": {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },
  "& .MuiStepConnector-line": {
    borderStyle: "dashed",
    borderWidth: ".15em",
    borderColor: theme.palette.primary.main,
    marginTop: theme.spacing(1),
    minHeight: orientation === "vertical" ? 40 : 2,
  },
  "& .MuiStepConnector-vertical": {
    marginLeft: 16,
    top: -27,
    left: "inherit !important",
    right: "inherit !important",
  },
  "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
    borderStyle: "solid",
  },
  "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
    borderStyle: "solid",
  },
}));